import { createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Abacus emulator", -1 /* HOISTED */)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode($setup["SpeedOption"]),
    _createVNode($setup["PrecisionOption"]),
    _createVNode($setup["Abacus"]),
    _createVNode($setup["OverflowWarning"]),
    _createVNode($setup["Keypad"]),
    _createVNode($setup["InstructionList"])
  ], 64 /* STABLE_FRAGMENT */))
}